import { DataBean } from "../DataBean";

export class PlanMaintenanceArea extends DataBean {

  public async getPlanMaintenanceAreaCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getPlanMaintenanceAreaCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getPlanMaintenanceAreaRender( page: number, rows: number, properties: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getPlanMaintenanceAreaRender_Number_Number_java.util.Map",
      [ page, rows, properties]
    );
  }

  public async confirmScheduleMaintenance(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.TechnicianAssignment_confirmScheduleMaintenance_java.util.Map",
      [bean]
    )
  }

  public async deletePlanMaintenanceArea(idplanmaintenancearea: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deletePlanMaintenanceArea_Number",
      [idplanmaintenancearea]
    );
  }


  public async updatePlanMaintenanceArea(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.PlanMaintenanceArea_updatePlanMaintenanceArea_com.orange.finance.processcontract.bean.PlanMaintenanceArea",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.PlanMaintenanceArea",
        },
      ]
    );
  }
}
